import EntityModel from '@/common/models/entity-model';

export default class LeadSourceModel extends EntityModel {
    hydrate({
        id = null,
        medium = null,
        source = null,
        campaign = null,
        term = null,
        content = null,
        affiliate = null,
        subAffiliate = null,
        salesAgent = null,
        clickId = null,
        path = null,
        ipAddress = null,
        currency = null,
        amount = null,
        original = null,
        createdTime = null,
        updatedTime = null,
    } = {}) {
        this.id = id;
        this.medium = medium;
        this.source = source;
        this.campaign = campaign;
        this.term = term;
        this.content = content;
        this.affiliate = affiliate;
        this.subAffiliate = subAffiliate;
        this.salesAgent = salesAgent;
        this.clickId = clickId;
        this.path = path;
        this.ipAddress = ipAddress;
        this.currency = currency;
        this.amount = amount;
        this.original = original;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
    }

    static editableFields = [
        'medium',
        'source',
        'campaign',
        'term',
        'content',
        'affiliate',
        'subAffiliate',
        'salesAgent',
        'clickId',
        'path',
        'ipAddress',
        'currency',
        'amount',
    ];

    get editableFields() {
        return LeadSourceModel.editableFields.filter(key => this[key]);
    }

    getPayload() {
        return this.editableFields.reduce((fields, key) => ({...fields, [key]: this[key]}), {});
    }
}
